import React from 'react';
import './CorporacionMunicipal.css';

import PSOE from '../../Images/Logotipo_PSOE.png';
import PP   from '../../Images/Logotipo_PartidoPopular.png';
import VOX  from '../../Images/Logotipo_VOX.jpg';
import EPT  from '../../Images/Logotipo_TLA.png';

/* --- datos del Pleno --- */
const bloquesPleno = [
  { etiqueta: 'Alcaldesa',            logo: PP,  miembros: ['Sonia María Gómez Fernández'] },
  { etiqueta: 'Concejales PP (3)',    logo: PP,  miembros: ['Susana Gómez Vallejo', 'Alicia Fuentes Alía', 'Abraham Moreno Otero'] },
  { etiqueta: 'Concejales VOX (2)',   logo: VOX, miembros: ['Francisco Javier Del Moral González', 'Carlos Jiménez Jiménez'] },
  { etiqueta: 'Concejales EPT (1)',   logo: EPT, miembros: ['Jesús Fuentes Sánchez'] },
  { etiqueta: 'Concejal No adscrito', logo: null, miembros: ['José Luis Grau Moreno'] },
  { etiqueta: 'Concejala PSOE (1)',   logo: PSOE, miembros: ['Marina Illescas Gutiérrez'] },
];


export default function CorporacionMunicipal() {
  return (
    <section className="corporacion-municipal">
      <div className="container">
        <h1>Corporación Municipal&nbsp;(Pleno)</h1>

        <div className="grid-bloques">
          {bloquesPleno.map((bloq, i) => (
            <div className="card-bloque" key={i}>
              <div className="info">
                <h3>{bloq.etiqueta}</h3>
                <ul>
                  {bloq.miembros.map((m, k) => <li key={k}>{m}</li>)}
                </ul>
              </div>

              {bloq.logo && (
                <div className="logo-box">
                  <img src={bloq.logo} alt="" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
